import React from "react";
import { DeliveryMethodWrapper } from "./styled";

const DELIVERY_METHOD_OPTIONS = [
    { value: "chat", label: "Chat" },
    { value: "sms", label: "SMS" },
    { value: "both", label: "Both" },
];

const DeliveryMethodSelector = ({ value, onChange, disabledField }) => (
    <DeliveryMethodWrapper>
        {DELIVERY_METHOD_OPTIONS.map((option) => (
            <button
                key={option.value}
                type="button"
                className={`${disabledField ? "disabled" : ""} ${value === option.value ? "active" : ""}`}
                onClick={() => onChange(option.value)}
                disabled={disabledField}
            >
                {option.label}
            </button>
        ))}
    </DeliveryMethodWrapper>
);

export default DeliveryMethodSelector;
